

















import {
  defineComponent,
} from '@vue/composition-api';
import { DialogView } from '@hb/coffee';

export default defineComponent({
  name: 'RetentionDialog',
  components: {
    DialogView,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'confirm'],
  setup(props, { emit }) {
    const handleClose = () => {
      emit('close');
    };

    const handleConfirm = () => {
      emit('confirm');
    };

    return {
      handleClose,
      handleConfirm,
    };
  },
});
